import { render, staticRenderFns } from "./WarningButton.vue?vue&type=template&id=0ff7843d&"
import script from "./WarningButton.vue?vue&type=script&lang=ts&"
export * from "./WarningButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports